export type CommentPosition = { left: number; top: number };
export type CommentBounds = { left: number; top: number; right: number; bottom: number };

// Fit the box inside the bounds. The caller keeps the dropped position as the
// anchor, so a temporary viewport constraint (scroll, resize) does not replace it.
export const constrainCommentPosition = (
	position: CommentPosition,
	width: number,
	height: number,
	bounds: CommentBounds,
): CommentPosition => ({
	left: Math.max(bounds.left, Math.min(position.left, bounds.right - width)),
	top: Math.max(bounds.top, Math.min(position.top, bounds.bottom - height)),
});
